import { SignOut, X } from "@phosphor-icons/react";
import { type JSX, useEffect } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";

import { Button } from "common/components/ui/Button";
import { useAuth } from "common/context/AuthContext";
import useWorkspaces from "common/datahooks/useWorkspaces";
import { getWhitelabelCustomization } from "common/helpers/utils";
import useAppStore from "common/hooks/useAppStore";
import useGTM from "common/hooks/useGTM";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import AimfoxLogo from "assets/aimfoxLogos/aimfox-logo-text.svg?react";

export default function BaseLayout() {
  const isDesktop = useTwBreakpoint("lg");
  const { pathname } = useLocation();
  const { sendEvent } = useGTM();
  const { logout } = useAuth();
  const { previousLocation } = useAppStore();
  const { workspaces } = useWorkspaces();

  useEffect(() => {
    sendEvent("virtualPageView", () => ({
      pageUrl: window.location.href,
      pagePath: pathname,
    }));
  }, [pathname]);

  let buttonComponent: JSX.Element;
  let logoComponent = getWhitelabelCustomization() ? (
    <img src={getWhitelabelCustomization().logo} className="max-h-14" alt="" />
  ) : (
    <AimfoxLogo />
  );

  if (pathname.includes("questionnaire")) {
    buttonComponent = isDesktop ? (
      <Button variant="secondary-black" onClick={logout} leftIcon={<SignOut />}>
        Log out
      </Button>
    ) : (
      <Button
        intent="iconOnly"
        size="lg"
        variant="secondary-black"
        onClick={logout}
      >
        <SignOut />
      </Button>
    );
  } else if (pathname.endsWith("/workspaces")) {
    const firstWorkspaceRoute = `${workspaces[0].id}`;

    logoComponent = <Link to={firstWorkspaceRoute}>{logoComponent}</Link>;

    buttonComponent = (
      <Button
        intent="iconOnly"
        size="lg"
        variant="outline-black"
        className="lg:hidden"
        asChild
      >
        <Link to={previousLocation || firstWorkspaceRoute}>
          <X />
        </Link>
      </Button>
    );
  }

  return (
    <>
      <header className="flex h-[68px] items-center justify-between px-4 bg-white max-lg:shadow-sm relative">
        {logoComponent}
        {buttonComponent}
      </header>

      <main className="bg-white flex flex-col lg:pt-1 p-4 min-h-[calc(100dvh-80px)]">
        <Outlet />
      </main>
    </>
  );
}
